
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/ocs/doctor/profile/[id]",
      function () {
        return require("private-next-pages/app/ocs/doctor/profile/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app/ocs/doctor/profile/[id]"])
      });
    }
  